import { themes } from 'src/theme/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  backgroundImage: {
    flex: 1,
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  imageStyle: {
    resizeMode: 'cover',
    opacity: 0.9,
  },
  ribbonImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '35%',
    zIndex: 5,
  },
  confettiContainer: {
    position: 'absolute',
    top: 40,
    left: '50%',
    transform: [{ translateX: -100 }], // Adjust to center
    zIndex: 10,
  },
  confettiImage: {
    width: 200,
    height: 200,
  },
  quoteCardContainer: {
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  textContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
    paddingTop: 60,
    paddingHorizontal: 10,
  },
  titleText: {
    textAlign: 'center',
  },
  subText: {
    textAlign: 'center',
    marginTop: 10,
  },
  cardCaptionContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardCaptionText: {
    textAlign: 'center',
  },
  cardCarousalContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  caraousalImage: {
    width: 343,
    height: 118,
  },
  feedbackButtonContainer: {
    marginTop: 20,
    alignItems: 'center',
  },
  quoteDetailsContainer: {
    marginTop: 20,
    paddingHorizontal: 15,
  },
  quoteDetailText: {
    fontSize: 16,
    marginBottom: 10,
  },
  quoteSummaryContainer: {
    backgroundColor: themes.light.white[1],
    borderRadius: 8,
    padding: 16,
    marginVertical: 16,
  },
  quoteSummaryLabel: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  quoteSummaryValue: {
    marginBottom: 12,
  },
});
